import { Button } from "@upstageai/ui";

import { Icon, Icons } from "../../components/Icon";
import { BaseTooltip } from "../../components/Tooltip/BaseTooltip";

interface ImagePageNavigationControlProps {
  pageIdx: number;
  pageSize: number;
  onPageSelect: (index: number) => void;
  onReset?: () => void;
}

export default function ImagePageNavigationControl({
  pageIdx,
  pageSize,
  onPageSelect,
  onReset,
}: ImagePageNavigationControlProps): JSX.Element {
  const pageNumber = pageIdx + 1;

  return (
    <div className="flex items-center justify-between">
      <BaseTooltip tooltipContent={<div>Previous page</div>}>
        <Button
          variant="ghost"
          size="icon"
          disabled={pageNumber === 1 || pageSize <= 1}
          onClick={() => {
            onReset?.();
            const nextPageIdx = Math.max(pageIdx - 1, 0);
            onPageSelect(nextPageIdx);
          }}
        >
          <Icon source={Icons.UpArrow} />
        </Button>
      </BaseTooltip>

      <BaseTooltip>
        <div className="subtle flex items-center justify-center gap-1">
          <span className="subtle w-4 text-right">{pageNumber}</span>
          <span className="text-center">/</span>
          <span className="w-4 text-start">{pageSize}</span>
        </div>
      </BaseTooltip>

      <BaseTooltip tooltipContent={<div>Next page</div>}>
        <Button
          variant="ghost"
          size="icon"
          disabled={pageNumber === pageSize || pageSize <= 1}
          onClick={() => {
            onReset?.();
            const nextPageIdx = Math.min(pageNumber + 1, pageSize) - 1;
            onPageSelect(nextPageIdx);
          }}
        >
          <Icon source={Icons.DownArrow} />
        </Button>
      </BaseTooltip>
    </div>
  );
}
